import { RndDossier } from '@data/utils/types';

/** The dossier as the form holds it: every field a string, because an empty one is `''` here and absent on the wire. */
export interface RndDossierDraft {
  context: string;
  existingKnowledge: string;
  advancement: string;
  obstacles: string;
  activities: string;
  academicCollaboration: '' | 'yes' | 'no';
  rndShare: string;
}

export const emptyDraft: RndDossierDraft = {
  context: '',
  existingKnowledge: '',
  advancement: '',
  obstacles: '',
  activities: '',
  academicCollaboration: '',
  rndShare: '',
};

/** The select's stand-in for "nobody has answered", since `''` is not a usable Select value. */
export const UNANSWERED = 'unanswered';

/** Anything that is not an answer is the unanswered state, not No. */
export const collaborationFrom = (value: string | null): '' | 'yes' | 'no' => {
  if (value === 'yes') return 'yes';
  if (value === 'no') return 'no';
  return '';
};

// '' carries "nobody has answered", which is not the same answer as No.
const collaborationOf = (answered?: boolean): '' | 'yes' | 'no' => {
  if (answered === undefined) return '';
  return answered ? 'yes' : 'no';
};

export const toDraft = (dossier?: RndDossier): RndDossierDraft => ({
  context: dossier?.context ?? '',
  existingKnowledge: dossier?.existingKnowledge ?? '',
  advancement: dossier?.advancement ?? '',
  obstacles: dossier?.obstacles ?? '',
  activities: dossier?.activities ?? '',
  academicCollaboration: collaborationOf(dossier?.academicCollaboration),
  rndShare: dossier?.rndShare === undefined ? '' : String(dossier.rndShare),
});

// Absent rather than `''`, so "not written yet" means the same thing on both sides.
const written = (value: string): string | undefined => (value.trim() ? value : undefined);

export const toDossier = (draft: RndDossierDraft): RndDossier => ({
  context: written(draft.context),
  existingKnowledge: written(draft.existingKnowledge),
  advancement: written(draft.advancement),
  obstacles: written(draft.obstacles),
  activities: written(draft.activities),
  academicCollaboration: draft.academicCollaboration === '' ? undefined : draft.academicCollaboration === 'yes',
  rndShare: draft.rndShare.trim() === '' ? undefined : Number(draft.rndShare),
});
